<template>
    <page>
        <div class="shadow-25 col-4">
            <v-header :title="'4001 - ' + $T('no lending point')" icon="error"/>
            <card title-inverted
                  title-color="primary"
                  footer-color="white"
                  width="100%">

                <div class="q-pa-xl text-center">
                    {{ $T('please contact tech support and ask for the correct association of your user to your lending point.') }}
                </div>
            </card>
        </div>
    </page>
</template>

<script>
    export default {
        layout: 'basic',
        name: 'NoLendingPoint',
        methods: {
            async autoLogoff () {
                await this.$store.dispatch('auth/logout')
            }
        },
        created () {
            this.autoLogoff()
        }        
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/errors/4001.vue